import React, { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate, matchPath } from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AnaSehife from './screens/AnaSehife';
import Auth from './screens/auth/Auth';
import Chat from './screens/chat/Chat';
import ElanYarat from './screens/elanlar/ElanYarat';
import Profile from './screens/profile/Profile';
import MotoTaksiSifarish from './screens/sifarish/MotoTaksiSifarish';
import Elanlar from './screens/elanlar/Elanlar';
import Elan from './screens/elanlar/Elan';
import EditElan from './screens/elanlar/EditElan';
import Dashboard from './screens/private/Dashboard';
import AdminLogin from './screens/private/auth/AdminLogin';
import ElanlarAdmin from './screens/private/elanlar/ElanlarAdmin';
import ElanAdmin from './screens/private/elanlar/ElanAdmin';
import EditElanAdmin from './screens/private/elanlar/EditElanAdmin';
import IstifadecilerAdmin from './screens/private/users/IstifadecilerAdmin';
import MotoTaksiSifarishAdmin from './screens/private/sifarish/MotoTaksiSifarishAdmin';
import ChatAdmin from './screens/private/chat/ChatAdmin';
import Contact from './screens/contact/Contact';
import About from './screens/about/About';
import LiveTrackingPage from './screens/location/LiveTrackingPage';
import PaymentSuccess from './screens/payment/PaymentSuccess';
import PaymentError from './screens/payment/PaymentError';
import PaymentResult from './screens/payment/PaymentResult';
import PrivacyPolicy from './screens/privacy/PrivacyPolicy';
import Lotoreya from './screens/lotoreya/Lotoreya';
import LotoreyaIstekleri from './screens/private/lotoreya/istekler/LotoreyaIstekleri';
import Lotoreyalar from './screens/private/lotoreya/Lotoreyalar';
import Carx from './screens/private/lotoreya/carx/Carx';
import QrKodDuzelt from './screens/private/qr-kod-duzelt/QrKodDuzelt';
import Yukle from './screens/yukle/Yukle';
import YukleLinkDuzelt from './screens/private/yukle-link-duzelt/YukleLinkDuzelt';
import CouriersubApp from './couriersub/CouriersubApp';
import MenuProApp from './menupro/MenuProApp';
import PublicMenu from './menupro/pages/PublicMenu';
import DevetLanding from './couriersub/pages/public/DevetLanding';
import SifarisQrupuApp from './sifarisqrupu/SifarisQrupuApp';
import Sened1 from './screens/sened/Sened1';
import Sened2 from './screens/sened/Sened2';

const AppLayout = () => {
  const location = useLocation();
  const isChatPage = location.pathname === '/chat';
  const isAuthenticated = localStorage.getItem('motoTaksiUserId'); // User ID localStorage-də yoxlanır
  const isAdminAuthenticated = localStorage.getItem('motoTaksiAdminId'); // Admin ID yoxlanır

  // Istifadəçi login olub olmadığını yoxlayırıq
  useEffect(() => {
    if (!isAuthenticated && ['/chat', '/elanyarat', '/profile', '/motosifarish', '/edit-elan'].includes(location.pathname)) {
      window.location.href = "/auth"; // Yönləndiririk /auth səhifəsinə
    }
  }, [isAuthenticated, location.pathname]);

  // Navbar və Footer yalnız bu səhifələrdə göstərilməyəcək
  const isAdminPage =
    location.pathname === '/admin-login' ||
    location.pathname === '/private' ||
    location.pathname === '/private/elanlar' ||
    location.pathname.startsWith('/private/elan/') ||
    location.pathname.startsWith('/private/edit-elan/') ||
    location.pathname === '/private/istifadeciler' ||
    location.pathname === '/private/sifarishler' ||
    location.pathname === '/private/chat' ||
    location.pathname === '/private/lotoreya' ||
    location.pathname.startsWith('/private/lotoreya/') ||
    location.pathname.startsWith('/location/');

  const isCourierSubPage = location.pathname.startsWith('/couriersub');

  const isSifarisPage = location.pathname.startsWith('/sifaris');

  const reserved = new Set([
    "/", "/auth", "/elaqe", "/haqqimizda", "/lotoreya", "/chat",
    "/elanyarat", "/profile", "/motosifarish",
    "/admin-login", "/private", "/privacy-policy",
    "/couriersub", "/menupro", "/success", "/error", "/result",
    "/qrkod", "/yukle"
  ]);

  const m = matchPath({ path: "/:slug", end: true }, location.pathname);
  const isPublicMenuPage = !!m && !reserved.has(location.pathname);

  const isMenuProPage = location.pathname.startsWith('/menupro') || isPublicMenuPage;

  return (
    <div className="app-wrapper">
      {!isAdminPage && !isChatPage && !isCourierSubPage && !isMenuProPage && !isSifarisPage && <Navbar />}
      <div
        style={{
          paddingBottom:
            (!isAdminPage && !isMenuProPage && !isCourierSubPage && !isSifarisPage)
              ? '100px'
              : '0'
        }}
      >
        <Routes>
          <Route path="/" element={<AnaSehife />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/elaqe" element={<Contact />} />
          <Route path="/haqqimizda" element={<About />} />
          <Route path="/lotoreya" element={<Lotoreya />} />
          <Route path="/chat" element={isAuthenticated ? <Chat /> : <Navigate to="/auth" />} />
          <Route path="/elanyarat" element={isAuthenticated ? <ElanYarat /> : <Navigate to="/auth" />} />
          <Route path="/profile" element={isAuthenticated ? <Profile /> : <Navigate to="/auth" />} />
          <Route path="/profile/sifarishlerim" element={isAuthenticated ? <Profile /> : <Navigate to="/auth" />} />
          <Route path="/profile/elanlarim" element={isAuthenticated ? <Profile /> : <Navigate to="/auth" />} />
          <Route path="/motosifarish" element={isAuthenticated ? <MotoTaksiSifarish /> : <Navigate to="/auth" />} />
          <Route path="/elanlar/:category" element={<Elanlar />} />
          <Route path="/elan/:id" element={<Elan />} />
          <Route path="/edit-elan/:id" element={isAuthenticated ? <EditElan /> : <Navigate to="/auth" />} />

          <Route path="/sened/sened1" element={<Sened1 />} />
          <Route path="/sened/sened2" element={<Sened2 />} />
          

          <Route path="/qrkod" element={<Yukle />} />
          <Route path="/yukle" element={<Yukle />} />
          {/* Admin login səhifəsi */}
          <Route
            path="/admin-login"
            element={isAdminAuthenticated ? <Navigate to="/private" /> : <AdminLogin />}
          />

          {/* Admin Dashboard */}
          <Route
            path="/private"
            element={isAdminAuthenticated ? <Dashboard /> : <Navigate to="/admin-login" />}
          />

          {/* Admin elanlar səhifəsi */}
          <Route
            path="/private/elanlar"
            element={isAdminAuthenticated ? <ElanlarAdmin /> : <Navigate to="/" />}
          />

          <Route
            path="/private/elan/:id"
            element={isAdminAuthenticated ? <ElanAdmin /> : <Navigate to="/" />}
          />

          <Route
            path="/private/edit-elan/:id"
            element={isAdminAuthenticated ? <EditElanAdmin /> : <Navigate to="/" />}
          />

          <Route
            path="/private/istifadeciler"
            element={isAdminAuthenticated ? <IstifadecilerAdmin /> : <Navigate to="/" />}
          />

          <Route
            path="/private/istifadeciler/:userId"
            element={isAdminAuthenticated ? <IstifadecilerAdmin /> : <Navigate to="/" />}
          />

          <Route
            path="/private/sifarishler"
            element={isAdminAuthenticated ? <MotoTaksiSifarishAdmin /> : <Navigate to="/" />}
          />

          <Route
            path="/private/chat"
            element={isAdminAuthenticated ? <ChatAdmin /> : <Navigate to="/" />}
          />

          <Route
            path="/private/lotoreya"
            element={isAdminAuthenticated ? <Lotoreyalar /> : <Navigate to="/" />}
          />

          <Route
            path="/private/lotoreya/istekler"
            element={isAdminAuthenticated ? <LotoreyaIstekleri /> : <Navigate to="/" />}
          />

          <Route
            path="/private/lotoreya/istekler/:elanId"
            element={isAdminAuthenticated ? <LotoreyaIstekleri /> : <Navigate to="/" />}
          />

          <Route
            path="/private/lotoreya/carx"
            element={isAdminAuthenticated ? <Carx /> : <Navigate to="/" />}
          />

          <Route
            path="/private/qr-kod-duzelt"
            element={isAdminAuthenticated ? <QrKodDuzelt /> : <Navigate to="/" />}
          />

          <Route
            path="/private/yukle-link-duzelt"
            element={isAdminAuthenticated ? <YukleLinkDuzelt /> : <Navigate to="/" />}
          />

          <Route
            path="/private/lotoreya/carx/:lotoreyaId"
            element={isAdminAuthenticated ? <Carx /> : <Navigate to="/" />}
          />

          <Route path="/location/:trackingId" element={<LiveTrackingPage />} />

          <Route path="/success" element={<PaymentSuccess />} />
          <Route path="/error" element={<PaymentError />} />
          <Route path="/result" element={<PaymentResult />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/couriersub/*" element={<CouriersubApp />} />

          <Route path="/sifaris/*" element={<SifarisQrupuApp />} />

          <Route path="/menupro/*" element={<MenuProApp />} />

          <Route path="/:slug" element={<PublicMenu />} />

          <Route path="/devet/:code" element={<DevetLanding />} />

        </Routes>

      </div>
      {!isAdminPage && !isChatPage && !isCourierSubPage && !isMenuProPage && !isSifarisPage && <Footer />}
    </div>
  );
};

export default AppLayout;

